<template>
    <q-layout view="hHh lpR fFf">
        <marketing-nav :mobile-nav-open="mobileNav" @toggle-mobile="mobileNav = !mobileNav" />

        <q-page-container>
            <!-- ============================================================
                 HERO
                 ============================================================ -->
            <section class="mkt-hero-light mkt-hero-watermark" style="padding:80px 0 50px;">
                <div class="mkt-hero-arcs" aria-hidden="true">
                    <svg class="mkt-hero-arc mkt-hero-arc--bl" viewBox="0 0 600 400" preserveAspectRatio="xMinYMax slice">
                        <defs>
                            <linearGradient id="arcGradBL" x1="0%" y1="100%" x2="100%" y2="0%">
                                <stop offset="0%" stop-color="#4F46E5" stop-opacity="0" />
                                <stop offset="38%" stop-color="#4F46E5" stop-opacity="1" />
                                <stop offset="100%" stop-color="#7C3AED" stop-opacity="0" />
                            </linearGradient>
                        </defs>
                        <g stroke="url(#arcGradBL)" stroke-width="0.7" fill="none">
                            <path d="M -50,350 Q 150,220 380,200 T 700,170" />
                            <path d="M -50,358 Q 155,230 385,210 T 700,180" />
                            <path d="M -50,366 Q 160,240 390,220 T 700,190" />
                            <path d="M -50,374 Q 165,250 395,230 T 700,200" />
                            <path d="M -50,382 Q 170,260 400,240 T 700,210" />
                            <path d="M -50,390 Q 175,270 405,250 T 700,220" />
                            <path d="M -50,398 Q 180,280 410,260 T 700,230" />
                            <path d="M -50,406 Q 185,290 415,270 T 700,240" />
                            <path d="M -50,414 Q 190,300 420,280 T 700,250" />
                            <path d="M -50,422 Q 195,310 425,290 T 700,260" />
                            <path d="M -50,430 Q 200,320 430,300 T 700,270" />
                            <path d="M -50,438 Q 205,330 435,310 T 700,280" />
                        </g>
                    </svg>
                    <svg class="mkt-hero-arc mkt-hero-arc--tr" viewBox="0 0 600 400" preserveAspectRatio="xMinYMax slice">
                        <defs>
                            <linearGradient id="arcGradTR" x1="0%" y1="100%" x2="100%" y2="0%">
                                <stop offset="0%" stop-color="#0EA5E9" stop-opacity="0" />
                                <stop offset="38%" stop-color="#0EA5E9" stop-opacity="1" />
                                <stop offset="100%" stop-color="#4F46E5" stop-opacity="0" />
                            </linearGradient>
                        </defs>
                        <g stroke="url(#arcGradTR)" stroke-width="0.7" fill="none">
                            <path d="M -50,350 Q 150,220 380,200 T 700,170" />
                            <path d="M -50,358 Q 155,230 385,210 T 700,180" />
                            <path d="M -50,366 Q 160,240 390,220 T 700,190" />
                            <path d="M -50,374 Q 165,250 395,230 T 700,200" />
                            <path d="M -50,382 Q 170,260 400,240 T 700,210" />
                            <path d="M -50,390 Q 175,270 405,250 T 700,220" />
                            <path d="M -50,398 Q 180,280 410,260 T 700,230" />
                            <path d="M -50,406 Q 185,290 415,270 T 700,240" />
                            <path d="M -50,414 Q 190,300 420,280 T 700,250" />
                            <path d="M -50,422 Q 195,310 425,290 T 700,260" />
                            <path d="M -50,430 Q 200,320 430,300 T 700,270" />
                            <path d="M -50,438 Q 205,330 435,310 T 700,280" />
                        </g>
                    </svg>
                </div>
                <div class="mkt-hero-watermark-icon mkt-hero-watermark-icon--right" aria-hidden="true">
                    <q-icon name="business" />
                </div>
                <div class="mkt-container text-center" style="position:relative;z-index:1;">
                    <span class="mkt-trust-pill mkt-trust-pill--light q-mb-md" style="display:inline-block;">
                        <q-icon name="business" class="mkt-trust-icon" /> For 3 to 100+ person teams
                    </span>
                    <h1 class="text-weight-bold q-mt-md q-mb-md" style="font-size:clamp(2rem,4vw,3rem);color:#0F172A;line-height:1.15;">
                        From small teams to<br>
                        <span class="text-gradient-indigo">growing enterprises.</span>
                        <span class="visually-hidden"> - eSign Launchpad for small business and enterprise teams with SSO and SCIM</span>
                    </h1>
                    <p class="q-mb-lg" style="font-size:1.1rem;max-width:640px;margin:0 auto;color:#475569;">
                        Four plans covering every team workflow: team signing, payment collection, full workflow automation,
                        and single sign-on identity. Pay only for what you send. Cancel anytime.
                    </p>
                    <div class="row justify-center q-gutter-md mkt-hero-cta-row">
                        <q-btn color="primary" size="lg" label="Get Started Free" href="/Account/Register"
                            no-caps unelevated style="border-radius:10px;padding:10px 32px;" />
                        <q-btn outline size="lg" no-caps label="See use cases" href="#use-cases" style="border-radius:10px;padding:10px 32px;color:#334155;border-color:#CBD5E1;" />
                    </div>
                </div>
            </section>

            <!-- ============================================================
                 USE CASES - 4 persona scenarios
                 ============================================================ -->
            <section id="use-cases" class="mkt-white reveal-fade-up" v-intersection="revealCfg" style="padding:60px 0;">
                <div class="mkt-container">
                    <div class="text-center q-mb-xl">
                        <div class="mkt-section-eyebrow">Use cases</div>
                        <h2 class="text-weight-bold q-mb-sm" style="font-size:clamp(1.6rem,3vw,2.2rem);color:#0a0f1a;">Which scenario is yours?</h2>
                        <p class="text-grey-7" style="font-size:1.05rem;max-width:600px;margin:0 auto;">
                            Click a scenario to see the recommended plan and why.
                        </p>
                    </div>
                    <div class="row q-col-gutter-lg items-stretch">
                        <div class="col-12 col-md-6" v-for="uc in useCases" :key="uc.key">
                            <q-card flat bordered class="mkt-scenario-card column full-height"
                                    style="border-radius:14px;overflow:hidden;">
                                <!-- Tinted header - overline (use case) + plan name + price.
                                     Background derives from plan color at ~9% alpha; border at ~25%. -->
                                <q-card-section :style="`background:${uc.color}17;border-bottom:1px solid ${uc.color}40;`">
                                    <div class="row items-center q-gutter-xs no-wrap">
                                        <q-icon :name="uc.icon" size="20px" :style="`color:${uc.color};`" />
                                        <div class="text-overline" :style="`color:${uc.color};line-height:1.2;letter-spacing:1px;font-weight:600;`">
                                            {{ uc.title }}
                                        </div>
                                    </div>
                                    <div class="text-h5 q-mt-sm text-weight-bold" style="color:#0a0f1a;line-height:1.2;">
                                        {{ uc.badge }}
                                    </div>
                                    <div class="text-caption text-grey-7">
                                        {{ uc.price }}
                                    </div>
                                </q-card-section>

                                <!-- Body - summary description. col=grow keeps card footers aligned. -->
                                <q-card-section class="col">
                                    <p class="text-grey-7 q-mb-none" style="font-size:0.95rem;line-height:1.6;">
                                        {{ uc.summary }}
                                    </p>
                                </q-card-section>

                                <q-separator />

                                <q-card-actions class="q-pa-md">
                                    <q-btn flat no-caps
                                           color="primary"
                                           :label="`See ${uc.badge} plan`"
                                           icon-right="arrow_forward"
                                           :href="`#plan-${uc.tier}`"
                                           style="font-weight:500;border-radius:8px;" />
                                </q-card-actions>
                            </q-card>
                        </div>
                    </div>
                </div>
            </section>

            <!-- ============================================================
                 FEATURES - comprehensive SMB feature set
                 ============================================================ -->
            <section id="features" class="mkt-light reveal-scale" v-intersection="revealCfg" style="padding:60px 0;">
                <div class="mkt-container">
                    <div class="text-center q-mb-xl">
                        <div class="mkt-section-eyebrow">Features</div>
                        <h2 class="text-weight-bold q-mb-sm" style="font-size:clamp(1.6rem,3vw,2.2rem);color:#0a0f1a;">Everything your team needs, by the time they need it</h2>
                        <p class="text-grey-7" style="font-size:1.05rem;max-width:620px;margin:0 auto;">
                            Workflow features scale with the plan. Start small on Starter; unlock SSO, audit trail, and 500 API signings on Business - self-serve.
                        </p>
                    </div>
                    <div class="row q-col-gutter-lg">
                        <div class="col-12 col-md-6 col-lg-4" v-for="f in features" :key="f.title">
                            <div class="mkt-card q-pa-lg" style="height:100%;">
                                <q-item class="q-pa-none q-mb-sm">
                                    <q-item-section avatar>
                                        <q-icon :name="f.icon" size="32px" :style="`color:${f.color};`" />
                                    </q-item-section>
                                    <q-item-section>
                                        <q-item-label class="text-weight-bold" style="font-size:1.05rem;color:#0a0f1a;line-height:1.25;">{{ f.title }}</q-item-label>
                                    </q-item-section>
                                </q-item>
                                <p class="text-grey-7 q-mb-sm" style="font-size:0.9rem;line-height:1.6;">{{ f.detail }}</p>
                                <div class="text-grey-6" style="font-size:0.78rem;text-transform:uppercase;letter-spacing:0.5px;">
                                    Available on {{ f.availableOn }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <!-- ============================================================
                 PRICING - all 4 SMB plans
                 ============================================================ -->
            <section id="pricing" class="mkt-white reveal-fade-up" v-intersection="revealCfg" style="padding:60px 0;">
                <div class="mkt-container">
                    <div class="text-center q-mb-xl">
                        <div class="mkt-section-eyebrow">Pricing</div>
                        <h2 class="text-weight-bold q-mb-sm" style="font-size:clamp(1.6rem,3vw,2.2rem);color:#0a0f1a;">Four plans, one natural upgrade path</h2>
                        <p class="text-grey-7" style="font-size:1rem;max-width:600px;margin:0 auto;">
                            Start on the Free tier with no credit card required. Upgrade to any paid plan when you're ready -
                            predictable per-signing overage as low as $0.25.
                        </p>

                        <!-- Billing toggle -->
                        <div class="row justify-center items-center q-gutter-sm q-mt-lg">
                            <span :style="!annual ? 'font-size:0.95rem;color:#0F172A;font-weight:600;' : 'font-size:0.95rem;color:#64748B;'">Monthly</span>
                            <q-toggle v-model="annual" color="primary" />
                            <span :style="annual ? 'font-size:0.95rem;color:#0F172A;font-weight:600;' : 'font-size:0.95rem;color:#64748B;'">
                                Annual
                                <q-badge color="primary" label="Save up to 25%" class="q-ml-xs" />
                            </span>
                        </div>
                    </div>
                    <div class="row q-col-gutter-lg justify-center">
                        <div class="col-12 col-sm-6 col-md-3" :id="`plan-starter`">
                            <plan-card tier-code="starter" :annual="annual" includes-label="For small teams:" />
                        </div>
                        <div class="col-12 col-sm-6 col-md-3" :id="`plan-collect`">
                            <plan-card tier-code="collect" :annual="annual" icon="payments" includes-label="For payment collection:" />
                        </div>
                        <div class="col-12 col-sm-6 col-md-3" :id="`plan-pro`">
                            <plan-card tier-code="pro" :annual="annual" featured includes-label="For growing teams:" />
                        </div>
                        <div class="col-12 col-sm-6 col-md-3" :id="`plan-business`">
                            <plan-card tier-code="business" :annual="annual" includes-label="For IT-led orgs:" />
                        </div>
                    </div>
                    <div class="text-center q-mt-xl">
                        <q-btn flat no-caps color="primary" label="See the full feature comparison"
                               icon-right="arrow_forward" href="/Home/Pricing"
                               style="font-size:0.95rem;font-weight:500;border-radius:8px;" />
                    </div>
                </div>
            </section>

            <!-- SSO spotlight: visual lead-in to the Enterprise section.
                 The Business-plan card above showed the price; this slide
                 reinforces that $149/mo is the actual sticker for SSO and
                 SCIM 2.0 - not a "starts at" or "contact sales" placeholder. -->
            <marketing-spotlight
                slug="spot-sso"
                alt="Enterprise SSO with SAML, OIDC, and SCIM 2.0 auto-provisioning on the Business plan at $149 per month"
                eyebrow-icon="admin_panel_settings"
                icon-circle-class="mkt-icon-circle--gold"
                title="Enterprise SSO without the enterprise contract"
                blurb="SAML, OIDC, and SCIM 2.0 auto-provisioning on the Business plan at $149/mo. No annual minimum, no sales call, no quote-and-haggle - configure your IdP in about ten minutes and go."
                :bullets="['SAML and OIDC with metadata-pinned signing certs', 'SCIM 2.0 auto-provisioning + admin approval queue', 'Two sign-in modes: SSO-only or SSO-preferred', 'Self-serve - configure Okta, Entra, Google, or JumpCloud yourself']"
                cta-label="See the Business plan"
                cta-href="#plan-business"
                flip />

            <!-- ============================================================
                 ENTERPRISE HIGHLIGHT - absorbed from Enterprise.vue
                 ============================================================ -->
            <section id="enterprise" class="mkt-light reveal-fade-in" v-intersection="revealCfg" style="padding:60px 0;">
                <div class="mkt-container">
                    <div class="text-center q-mb-xl">
                        <div class="mkt-section-eyebrow">Enterprise-ready, self-serve</div>
                        <h2 class="text-weight-bold q-mb-sm" style="font-size:clamp(1.5rem,2.8vw,2rem);color:#0a0f1a;">Identity, compliance, and scale at SMB pricing</h2>
                        <p class="text-grey-7" style="font-size:1rem;max-width:640px;margin:0 auto;">
                            The $149/mo Business plan includes single sign-on, auto-provisioning, hash-chained audit trail,
                            and 500 API signings. Self-serve from day one. Month-to-month.
                        </p>
                    </div>
                    <div class="row q-col-gutter-lg">
                        <div class="col-12 col-sm-6 col-md-4" v-for="block in enterpriseBlocks" :key="block.title">
                            <div class="mkt-card q-pa-lg" style="height:100%;">
                                <q-item class="q-pa-none q-mb-sm">
                                    <q-item-section avatar>
                                        <q-icon :name="block.icon" size="32px" :style="`color:${block.color};`" />
                                    </q-item-section>
                                    <q-item-section>
                                        <q-item-label class="text-weight-bold" style="font-size:1.05rem;color:#0a0f1a;line-height:1.25;">{{ block.title }}</q-item-label>
                                    </q-item-section>
                                </q-item>
                                <p class="text-grey-7 q-mb-sm" style="font-size:0.88rem;line-height:1.6;">{{ block.description }}</p>
                                <ul style="padding-left:18px;margin:0;font-size:0.85rem;color:#555;line-height:1.6;">
                                    <li v-for="item in block.items" :key="item">{{ item }}</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <!-- ============================================================
                 FINAL CTA
                 ============================================================ -->
            <section class="mkt-cta-gradient reveal-scale" v-intersection="revealCfg" style="padding:60px 0;">
                <div class="mkt-container text-center">
                    <h2 class="text-white text-weight-bold q-mb-md" style="font-size:1.8rem;">Start on Free. Upgrade when you're ready.</h2>
                    <p class="text-white q-mb-lg" style="opacity:0.9;font-size:1rem;">No credit card to sign up. No auto-charge. Cancel anytime on paid plans.</p>
                    <q-btn color="white" text-color="primary" size="lg" label="Get Started Free" href="/Account/Register"
                        no-caps unelevated style="border-radius:10px;padding:10px 36px;font-weight:600;" />
                </div>
            </section>

            <marketing-footer />
        </q-page-container>
    </q-layout>
</template>

<script>
import PlanCard from '@components/marketing/PlanCard.vue';
import MarketingNav from '@components/marketing/MarketingNav.vue';
import MarketingFooter from '@components/marketing/MarketingFooter.vue';
import MarketingSpotlight from '@components/marketing/MarketingSpotlight.vue';
import { revealMixin } from '@util/reveal.js';

export default {
    name: 'SmallBusinessPage',
    mixins: [revealMixin],
    components: { PlanCard, MarketingNav, MarketingFooter, MarketingSpotlight },
    data() {
        return {
            mobileNav: false,
            annual: false,

            // Four use-case cards = the four absorbed persona scenarios.
            // Each links down to its recommended plan card via the #plan-* anchor.
            useCases: [
                {
                    key: 'small-team',
                    title: 'Small team signings',
                    badge: 'Starter',
                    price: '$19/mo · 25 signings · 3 users',
                    tier: 'starter',
                    icon: 'groups',
                    color: '#2563EB',
                    summary: 'A 3-5 person agency or consultancy sending a handful of contracts a month. You need embedded signing and templates with predictable per-seat pricing.'
                },
                {
                    key: 'collect',
                    title: 'Sign & collect deposits',
                    badge: 'Sign & Collect',
                    price: '$39/mo · 50 signings · 2.5% platform fee',
                    tier: 'collect',
                    icon: 'payments',
                    color: '#047857',
                    summary: 'Freelance attorneys, contractors, small landlords. Client signs the contract and pays the deposit in the same flow. Money hits your bank account before the ink dries.'
                },
                {
                    key: 'growing-team',
                    title: 'Scale a business',
                    badge: 'Pro',
                    price: '$59/mo · 500 signings · 5 users · 2% fee',
                    tier: 'pro',
                    icon: 'trending_up',
                    // Teal - matches Sign_SubscriptionPlans.DisplayColor='teal' for Pro,
                    // which is the same color PlanCard renders. Avoids a color clash
                    // with Starter's blue (#2563EB) which used to look near-identical.
                    color: '#0D9488',
                    summary: 'A 10-30 person company with mature workflow needs. Branding, bulk send, webhooks, payment collection, light API access - all in one subscription.'
                },
                {
                    key: 'it-admin',
                    title: 'Enterprise identity',
                    badge: 'Business',
                    price: '$149/mo · 2,000 signings · 10 users · SSO + auto-provisioning',
                    tier: 'business',
                    icon: 'admin_panel_settings',
                    color: '#B45309',
                    summary: '50-100 person SMB with an IT lead who wants Okta/Entra integration. Self-serve SSO + SCIM in about 10 minutes. Hash-chained audit trail. No sales call required.'
                }
            ],

            // Feature grid - the full spread of capabilities SMBs care about.
            // `availableOn` labels tell the reader where each feature first unlocks.
            features: [
                { title: 'Send & Sign',          icon: 'send',                  color: '#047857',
                    detail: 'Drag-and-drop PDF or DOCX. 18 field types. Smart auto-detection.',
                    availableOn: 'All plans' },
                { title: 'Templates & bulk send', icon: 'content_copy',          color: '#2563EB',
                    detail: 'Reusable templates with pre-placed fields. Bulk-send to many recipients.',
                    availableOn: 'Starter (templates) · Pro (bulk send)' },
                { title: 'Payment collection',   icon: 'payments',              color: '#B45309',
                    detail: 'Collect deposits during signing. Funds settle directly to your bank account.',
                    availableOn: 'Sign & Collect · Pro · Business' },
                { title: 'Custom branding',      icon: 'palette',               color: '#7C3AED',
                    detail: 'Logo, colors, reply-to address on every signing surface.',
                    availableOn: 'Pro · Business' },
                { title: 'Developer API + events', icon: 'code',                color: '#4F46E5',
                    detail: 'Embed signing in your app. 22+ API endpoints, real-time event notifications, cryptographically signed.',
                    availableOn: 'Pro (100/mo) · Business (500/mo)' },
                { title: 'SSO + auto-provisioning', icon: 'admin_panel_settings', color: '#B45309',
                    detail: 'Single sign-on with Okta, Entra ID, JumpCloud, Google Workspace. Automatic user provisioning.',
                    availableOn: 'Business' },
                { title: 'Signer authentication', icon: 'fingerprint',           color: '#047857',
                    detail: 'SMS, KBA, or government-ID check. Per-signer configurable.',
                    availableOn: 'All plans · free allowance on Business' },
                { title: 'Hash-chained audit',   icon: 'verified',              color: '#4F46E5',
                    detail: 'IP + timestamp on every event. SHA-256 chain detects tampering.',
                    availableOn: 'All plans' },
                { title: 'Approval workflows',   icon: 'task_alt',              color: '#2563EB',
                    detail: 'Route through legal or compliance before signers get the doc.',
                    availableOn: 'Pro · Business' }
            ],

            // Enterprise blocks - absorbed from the former Enterprise.vue page.
            // Content re-scoped to the Business plan (the nav's "Enterprise" target
            // is self-serve Business, not a custom contract tier).
            enterpriseBlocks: [
                { icon: 'fingerprint', color: '#047857', title: 'SSO & user provisioning',
                    description: 'Plug in your identity provider. Auto-provision users. Centralized control.',
                    items: ['Single sign-on (SAML 2.0)', 'Automatic user provisioning', 'Okta, Entra ID, JumpCloud, Google', 'Auto-create on first login', 'Group-to-role mapping'] },
                { icon: 'code', color: '#2563EB', title: 'Developer API & events',
                    description: 'Build signing into your product. Real-time event notifications.',
                    items: ['22+ API endpoints', '24 event types', 'Cryptographically signed', 'Embedded iframe signing', '500 API signings/mo', 'AI-agent integration'] },
                { icon: 'verified_user', color: '#B45309', title: 'Compliance & audit',
                    description: 'Tamper-evident logs, certificates, evidence bundles.',
                    items: ['Enterprise cloud infrastructure', 'ESIGN Act & UETA compliant', 'Hash-chained audit log', 'Certificate of completion', '7-year retention', 'Evidence ZIP export'] },
                { icon: 'palette', color: '#7C3AED', title: 'White-label & branding',
                    description: 'Make the signing experience entirely yours.',
                    items: ['Logo on ceremony', 'Brand color scheme', 'Branded emails', 'White-label URL', 'Custom company name'] },
                { icon: 'lock', color: '#2563EB', title: 'Security & encryption',
                    description: 'Bank-level encryption end-to-end. Per-customer data isolation.',
                    items: ['256-bit encryption at rest', 'Encrypted in transit', 'Customer data isolation', 'IP logged on every action'] },
                { icon: 'badge', color: '#B45309', title: 'Identity verification',
                    description: 'SMS, KBA, or Persona ID. Configurable per signer.',
                    items: ['SMS one-time password', 'KBA quiz', 'Persona ID verification', '15 free IDV + 10 free KBA/mo on Business', 'SMS free on Business'] }
            ]
        };
    }
};
</script>

<style scoped>
.mkt-section-eyebrow {
    display: inline-block;
    font-size: 0.8rem;
    font-weight: 700;
    color: #4F46E5;
    text-transform: uppercase;
    letter-spacing: 1px;
    margin-bottom: 6px;
}
.mkt-scenario-card {
    transition: transform 0.15s ease, box-shadow 0.15s ease;
}
.mkt-scenario-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 24px rgba(0,0,0,0.08);
}
</style>
